// extracted by mini-css-extract-plugin
export default {"custom-image-wrapper":"Tmpl21_custom-image-wrapper__V4RH0"};